module.exports = __webpack_public_path__ + "static/media/icon-auto-connect-blue.e6e5ebed.png";